import React, { useState } from 'react';
import { FaFacebook, FaLinkedin, FaInstagram, FaTiktok, FaArrowLeft } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';

const TermsAndConditions = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ flex: 1 }}>
        
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', backgroundColor: '#fff', minHeight: '100vh' }}>
      
      <div style={{ lineHeight: '1.6', color: '#333' }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '1rem', fontSize: '2.5rem', fontWeight: '700' }}>
          LYNCFIT LTD Terms and Conditions
        </h1>
        
        <p style={{ fontStyle: 'italic', marginBottom: '2rem', color: '#666' }}>
          Last updated: 11 July 2025
        </p>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Introduction
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            These Terms and Conditions ("Terms") govern your use of the LyncFit website and mobile applications ("Services"). By accessing or using our Services, you agree to these Terms and our Privacy Policy.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Definitions
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Services:</strong> The LyncFit website, mobile applications, and related offerings.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>User Content:</strong> Any data, images, or information you upload or share via our Services.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            User Eligibility
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Users must be at least 18 years old.</li>
            <li style={{ marginBottom: '0.5rem' }}>Use of the Services is not permitted where prohibited by law.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Permitted Use
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>You may use LyncFit only for lawful, personal purposes.</li>
            <li style={{ marginBottom: '0.5rem' }}>You must not copy, modify, reverse engineer, or distribute any part of the Services.</li>
            <li style={{ marginBottom: '0.5rem' }}>Automated access (e.g., bots or scrapers) is prohibited.</li>
            <li style={{ marginBottom: '0.5rem' }}>You must not upload prohibited or unlawful content.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Content Responsibility
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>You are responsible for any content you upload or share.</li>
            <li style={{ marginBottom: '0.5rem' }}>Do not include personal contact details in public content.</li>
            <li style={{ marginBottom: '0.5rem' }}>By uploading content, you grant LYNCFIT LTD a worldwide, non-exclusive, royalty-free licence to use and display your content in connection with the Services.</li>
            <li style={{ marginBottom: '0.5rem' }}>LYNCFIT LTD may remove or moderate content at its discretion.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Interactions and Events
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>LYNCFIT LTD connects users for fitness activities and events but does not supervise or control user interactions.</li>
            <li style={{ marginBottom: '0.5rem' }}>Participation in any event is at your own risk. LYNCFIT LTD disclaims liability for injuries, damages, or dissatisfaction arising from events or user interactions.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Intellectual Property
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>All content, trademarks, and intellectual property on the Services belong to LYNCFIT LTD or its licensors.</li>
            <li style={{ marginBottom: '0.5rem' }}>You may not use, copy, or distribute any part of the Services without written permission.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            App Updates and External Services
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>You are responsible for keeping your app updated.</li>
            <li style={{ marginBottom: '0.5rem' }}>LYNCFIT LTD is not responsible for third-party services or external links accessed through the app.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Limitation of Liability
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>LYNCFIT LTD provides the Services "as is" and does not guarantee uninterrupted or error-free operation.</li>
            <li style={{ marginBottom: '0.5rem' }}>To the extent permitted by law, LYNCFIT LTD's liability is limited and does not cover indirect, incidental, or consequential damages.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Indemnification
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            You agree to indemnify and hold harmless LYNCFIT LTD, its officers, employees, and agents from any claims, losses, or damages arising from your breach of these Terms or misuse of the Services.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Termination
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            LYNCFIT LTD may terminate your access to the Services if you breach these Terms. You may delete your account at any time.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Governing Law and Dispute Resolution
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            These Terms are governed by the laws of England and Wales. Disputes will be resolved through good faith mediation before any legal proceedings. For mediation, we recommend the Centre for Effective Dispute Resolution (CEDR) or a similar body.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Changes to These Terms
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We reserve the right to update these Terms from time to time. The latest version will be posted on our website with the revised date.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Contact
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            For any questions about these Terms or our Privacy Policy, please contact:
          </p>
          <p style={{ fontWeight: '600', color: '#007bff' }}>
            info@lyncfit.co.uk
          </p>
        </section>
      </div>
    </div>

  

      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;